export default {
    areANIFieldsRequired: (hasAddlNamedInsured) => {
        return hasAddlNamedInsured;
    },
    isMultiProductPolicyNumberValid: (multiProductPolicyNumberValid) => {
        return multiProductPolicyNumberValid;
    }
};
